import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { Grid, Box } from '@mui/material'

/**
 * Compact section — lighter py than shared Background so adjacent zone
 * blocks don't stack large top+bottom padding between panel rows.
 */
export const FeaturesSection = styled.section`
  width: 100%;
  padding: 0.5rem 0;
`

export const PanelGridContainer = styled(Grid)<CmsProps>`
  h1,
  h2,
  h3,
  h4 {
    margin: 0 0 1.25rem;
  }

  p {
    margin: 0;
  }

  li {
    list-style: none;
  }

  img {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    object-fit: contain;
  }
`

export const PanelItem = styled(Box, {
  shouldForwardProp: prop =>
    isPropValid(prop) && !['backgroundColor', 'textColour'].includes(prop),
})<CmsProps>`
  background-color: ${({ backgroundColor }) => backgroundColor ?? '#f7f8f9'};
  color: ${({ textColour }) => textColour ?? '#000'};
  padding: 1.75rem 1.5rem;
  height: 100%;
  border-radius: 2px;
`

export const FeatureList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`
